import { render, staticRenderFns } from "./Fallback.vue?vue&type=template&id=3f0ccaad&scoped=true&"
import script from "./Fallback.vue?vue&type=script&lang=js&"
export * from "./Fallback.vue?vue&type=script&lang=js&"
import style0 from "./Fallback.vue?vue&type=style&index=0&id=3f0ccaad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ccaad",
  null
  
)

export default component.exports